/**
 * Bundled invite config (same shape as public/AppData.json `data`).
 * Edit here for production; guest names still load from the API.
 * Regenerate from JSON: node scripts/genAppStaticData.js
 */
export const APP_STATIC_DATA = {
  "assetsVersion": 3,
  "settings": {
    "defaultLang": "en",
    "countdownTargetIso": "2026-06-20T19:30:00+03:00",
    "timeZone": "Asia/Beirut"
  },
  "display": {
    "slide1": {
      "husband": "en",
      "bride": "en",
      "ampersand": "en"
    },
    "slide2": {
      "husband": "en",
      "bride": "en",
      "ampersand": "en"
    }
  },
  "ui": {
    "welcome": {
      "en": "Welcome",
      "ar": "أهلاً وسهلاً",
      "lang": "en"
    },
    "startLines": {
      "en": [
        "Open",
        "your",
        "invitation"
      ],
      "ar": [
        "افتح",
        "دعوتك",
        ""
      ],
      "lang": "en"
    },
    "envelopeFeel": {
      "enabled": true,
      "sealLogoSrc": "/img/Logo.jpeg",
      "colors": {
        "paper1": "#5c4430",
        "paper2": "#785c44",
        "paper3": "#4a3426",
        "paperAlpha1": 0.52,
        "paperAlpha2": 0.46,
        "paperAlpha3": 0.55,
        "flapSide1": "#87694e",
        "flapSide2": "#5f4634",
        "flapSideAlpha1": 0.58,
        "flapSideAlpha2": 0.62,
        "flapBottom1": "#6e523c",
        "flapBottom2": "#553e2e",
        "flapBottomAlpha1": 0.6,
        "flapBottomAlpha2": 0.64,
        "flapTop1": "#967658",
        "flapTop2": "#694e3a",
        "flapTopAlpha1": 0.62,
        "flapTopAlpha2": 0.58,
        "kraftInsetShadow": "rgba(30, 18, 10, 0.28)",
        "sealHighlight": "rgba(110, 48, 52, 0.45)",
        "sealMid": "#5c2428",
        "sealDeep": "#451a20",
        "sealInk": "#2d1014",
        "sealVoid": "#160809",
        "sealEdge": "rgba(60, 28, 32, 0.5)",
        "sealRim": "rgba(25, 10, 12, 0.65)",
        "sealInsetTop": "rgba(95, 42, 48, 0.35)",
        "sealInsetBottom": "rgba(8, 2, 4, 0.75)",
        "sealInsetHighlight": "rgba(130, 72, 78, 0.12)",
        "sealRing": "rgba(140, 112, 62, 0.42)",
        "sealShine": "rgba(200, 150, 145, 0.22)",
        "textWelcome": "#f5ebe0",
        "textGuest": "#edd6c9",
        "textLine": "#e8dccf",
        "textLineLead": "#f0d6d8",
        "textHint": "rgba(232, 220, 207, 0.72)",
        "ornament": "rgba(45, 28, 18, 0.65)"
      }
    },
    "curtainFeel": {
      "enabled": false,
      "colors": {
        "fabric1": "rgba(120, 18, 28, 0.92)",
        "fabric2": "rgba(55, 8, 14, 0.94)",
        "fold": "rgba(255, 255, 255, 0.08)",
        "shadow": "rgba(0, 0, 0, 0.58)"
      }
    },
    "bookPageSwipe": {
      "enabled": false,
      "perspectivePx": 1180,
      "maxAngleDeg": 46,
      "depthPx": 24,
      "curve": 1.42,
      "cornerLiftDeg": 17,
      "hingeYPercent": 92,
      "easeExponent": 0.84,
      "curlExtraDeg": 14,
      "shadowStrength": 1,
      "foreshortenMin": 0.8
    },
    "leaves": {
      "enabled": true,
      "count": 18,
      "images": [
        "/img/realLeaf1.png",
        "/img/realLeaf2.png",
        "/img/realLeaf3.png",
        "/img/realLeaf4.png"
      ]
    },
    "swipeLeft": {
      "en": "SWIPE LEFT",
      "ar": "اسحب لليسار",
      "lang": "en"
    },
    "slide1": {
      "gettingMarried": {
        "en": "Are Getting Married",
        "ar": "يتشرفان بدعوتكم لحفل زفافهما",
        "lang": "en"
      },
      "countdownCaption": {
        "en": "Counting down to our special day",
        "ar": "العد التنازلي ليومنا المميز",
        "lang": "en"
      }
    },
    "countdownUnits": {
      "days": {
        "en": "Days",
        "ar": "يوم",
        "lang": "en"
      },
      "hours": {
        "en": "Hours",
        "ar": "ساعة",
        "lang": "en"
      },
      "minutes": {
        "en": "Minutes",
        "ar": "دقيقة",
        "lang": "en"
      },
      "seconds": {
        "en": "Seconds",
        "ar": "ثانية",
        "lang": "en"
      }
    },
    "countdownScratch": {
      "enabled": false,
      "coverText": {
        "en": "Scratch",
        "ar": "اكشط",
        "lang": "en"
      },
      "coverColor": "rgba(255,255,255,0.92)",
      "revealThreshold": 0.42,
      "brushRadiusPx": 14
    },
    "locationMap": {
      "en": "Location Map",
      "ar": "الموقع على الخريطة",
      "lang": "en"
    },
    "rsvp": {
      "accept": {
        "en": "Accept",
        "ar": "أقبل",
        "lang": "en"
      },
      "decline": {
        "en": "Decline",
        "ar": "اعتذر",
        "lang": "en"
      },
      "submit": {
        "en": "RSVP",
        "ar": "تأكيد الحضور",
        "lang": "en"
      }
    },
    "lastPage": {
      "lines": [
        {
          "en": "Your presence and prayers",
          "ar": "وجودكن فرحتنا!",
          "lang": "ar"
        }
      ],
      "logoSrc": "/img/Logo.jpeg",
      "tapFireworks": {
        "enabled": true,
        "showHint": true,
        "hint": {
          "en": "Tap anywhere for your own fireworks ✨",
          "ar": "اضغط في أي مكان لإطلاق الألعاب النارية ✨",
          "lang": "en"
        }
      },
      "fireworksBrightness": 1.2,
      "fireworksTapMax": 26
    },
    "ampersand": {
      "en": "&",
      "ar": "&",
      "lang": "en"
    }
  },
  "backgroundMusic": {
    "enabled": true,
    "src": "/audio/FallinginLove.mp3"
  },
  "globalBackgroundVideo": {
    "enabled": false,
    "src": "/video/Chris.mp4"
  },
  "startPageMedia": {
    "type": "image",
    "src": "/img/HomePage.jpg"
  },
  "slideMedia": {
    "slide1": {
      "type": "image",
      "src": "/img/Page1.jpg"
    },
    "slide2": {
      "type": "image",
      "src": "/img/Page2.jpg"
    },
    "slide3": {
      "type": "image",
      "src": "/img/Page3.jpg"
    },
    "slide4": {
      "type": "image",
      "src": "/img/Page4.jpg"
    },
    "slide5": {
      "type": "image",
      "src": "/img/Page5.jpg"
    },
    "slide6": {
      "type": "image",
      "src": "/img/Page6.jpg"
    }
  },
  "husband": {
    "en": "Toufic",
    "ar": "توفيق"
  },
  "bride": {
    "en": "Reine",
    "ar": "رين"
  },
  "bibleQuotes": {
    "en": "“What therefore God hath joined together, let not man put asunder.”",
    "ar": "‘فَالَّذِي جَمَعَهُ ٱللَّهُ لَا يُفَرِّقُهُ إِنْسَانٌ’",
    "lang": "ar"
  },
  "evangelist": {
    "en": "",
    "ar": "(إنجيل متّى 19:6)",
    "lang": "ar"
  },
  "marriageQuotes": {
    "en": [
      "Imad & Isabelle Youssef",
      "&",
      "Boulous & Suzanne Farid",
      "They joyfully invite you to witness the eternal blessings exchanged by their children."
    ],
    "ar": [
      "عماد وإيزابيل يوسف",
      "&",
      "بولس وسوزان فريد",
      "بيسعدن يعزموكن تشاركوهن فرحتن وتشهدوا على نعمة الحبّ الأبدي يلي رح يتبادلوها ولادن"
    ],
    "lang": "ar"
  },
  "slide2Typography": {
    "fillPage": true,
    "compact": false
  },
  "slide2CeremonyLead": {
    "en": "",
    "ar": "وذلك نهار السبت الواقع فيه {date}",
    "lang": "ar"
  },
  "slide2CeremonySubline": {
    "en": "On Saturday the 20th of June, 2026",
    "ar": "السبت ٢٠ حزيران ٢٠٢٦",
    "lang": "en"
  },
  "ceremonyDateShort": {
    "en": "June 20, 2026",
    "ar": "٢٠ حزيران ٢٠٢٦"
  },
  "ceremony": {
    "title": {
      "en": "Wedding Ceremony",
      "ar": "القداس الإلهي",
      "lang": "en"
    },
    "dateLine": {
      "en": "On Saturday the 20th of June, 2026",
      "ar": "السبت ٢٠ حزيران ٢٠٢٦",
      "lang": "ar"
    },
    "time": {
      "en": "7:30 PM",
      "ar": "الساعة ٧:٣٠ مساءً",
      "lang": "ar"
    },
    "church": {
      "en": "Deir El Mokhallas Church",
      "ar": "في كنيسة مار روكس",
      "lang": "ar"
    },
    "churchNote": {
      "en": "",
      "ar": "",
      "lang": "ar"
    },
    "location": {
      "en": "Hazmieh",
      "ar": "الحازميّة",
      "lang": "ar"
    },
    "googleMap": "https://maps.app.goo.gl/SNGBuPgwFEEhcoWq9?g_st=aw"
  },
  "thanksQuote": {
    "en": "Together, let's mark the beginning of forever!",
    "ar": "معاً نبدأ إلى الأبد!",
    "lang": "en"
  },
  "dinner": {
    "dinnerTitle": {
      "en": "Welcome Drink & Dinner",
      "ar": "حفل شرب وعشاء",
      "lang": "en"
    },
    "dinnerDate": {
      "en": "Following the ceremony — dinner celebration",
      "ar": "يلي الاكليل حفل عشاء",
      "lang": "ar"
    },
    "dinnerTime": {
      "en": "8:30 PM",
      "ar": "الساعة ٨:٣٠ مساءً",
      "lang": "ar"
    },
    "dinnerResto": {
      "en": "Byblos Palace",
      "ar": "في The Grandhouse ",
      "lang": "ar"
    },
    "dinnerLocation": {
      "en": "Byblos",
      "ar": "دكوانه مار روكز",
      "lang": "ar"
    },
    "dinnerGoogleMap": "https://maps.app.goo.gl/TLm5kvdoZwhynteG6?g_st=aw"
  },
  "gift": {
    "giftRegistryTitle": {
      "en": "Gift Registry",
      "ar": "قائمة الهدايا",
      "lang": "en"
    },
    "lines": [
      {
        "en": "For those who wish: the gift registry at Whish (all branches)",
        "ar": "لمن يرغب، لائحة الهدايا",
        "lang": "ar"
      },
      {
        "en": "Whish (All Branches)",
        "ar": "",
        "lang": "en"
      }
    ],
    "brandLogoSrc": "/img/image01.png",
    "accountLabel": {
      "en": "Account ID:",
      "ar": "رقم الحساب:",
      "lang": "en"
    },
    "giftRegistryID": "20275961"
  },
  "rsvp": {
    "rsvpTitle": {
      "en": "Be Our Guest",
      "ar": "كن ضيفنا",
      "lang": "en"
    },
    "rsvpReplyDate": {
      "en": "Please let us know if you'll be celebrating with us – RSVP by 10 June 2026",
      "ar": "لمن يرغب الحضور، الرجاء التأكيد قبل ١٠ حزيران ٢٠٢٦",
      "lang": "en"
    }
  },
  "scrollSinglePage": {
    "enabled": false,
    "scrollHint": {
      "en": "Scroll down",
      "ar": "مرّر لأسفل",
      "lang": "en"
    }
  },
  "calendarAdd": {
    "enabled": false,
    "includeDinner": true,
    "ceremonyDurationMinutes": 90,
    "dinnerDurationMinutes": 150,
    "dinnerOffsetMinutesFromCeremonyStart": 60,
    "dinnerStartIso": null,
    "showGoogleCalendar": true,
    "showIcsDownload": true,
    "ceremonyTitle": {
      "en": "Wedding ceremony",
      "ar": "قداس الزفاف",
      "lang": "en"
    },
    "ceremonyDescription": null,
    "dinnerTitle": {
      "en": "Wedding reception",
      "ar": "حفل العشاء",
      "lang": "en"
    },
    "dinnerDescription": null,
    "labels": {
      "ceremonyBadge": {
        "en": "Save the date",
        "ar": "احفظ التاريخ",
        "lang": "en"
      },
      "dinnerBadge": {
        "en": "Reception",
        "ar": "الحفل",
        "lang": "en"
      },
      "addGoogle": {
        "en": "Google Calendar",
        "ar": "تقويم جوجل",
        "lang": "en"
      },
      "addIcs": {
        "en": "Apple / Outlook (.ics)",
        "ar": "ملف التقويم (.ics)",
        "lang": "en"
      }
    }
  }
};
